module.exports = __webpack_public_path__ + "img/26-dodge-durango.b7d191d2.jpg";